<template>
  <v-container class="fill-height">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="8" md="8">
        <div class="login">
          <div class="login-bg-img-container"></div>
          <div class="contentSection">
            <div class="lol">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26.56"
                height="26.749"
                viewBox="0 0 26.56 26.749"
              >
                <g transform="translate(-141.28 -378.225)">
                  <g transform="translate(141.28 378.225)">
                    <path
                      class="a"
                      d="M164.665,385.246A3.759,3.759,0,1,0,160.9,389a3.753,3.753,0,0,0,3.765-3.75m-14.693-6.986c-.5.193-.926.342-1.342.522a6.733,6.733,0,0,0-3.42,2.973,8.035,8.035,0,0,0-.861,2.947,25.07,25.07,0,0,0,.145,5.191c.167,1.737.324,3.473.45,5.212a13.776,13.776,0,0,1-.555,5.281,21.651,21.651,0,0,1-.872,2.018,1.967,1.967,0,0,0-.108.215.155.155,0,0,0,.027.141.151.151,0,0,0,.142-.005.859.859,0,0,0,.186-.153,7.818,7.818,0,0,1,4.472-2.152,17.252,17.252,0,0,1,4.869-.007c1.713.212,3.421.471,5.135.68a26.333,26.333,0,0,0,2.7.217,6.4,6.4,0,0,0,2.4-.354,3.214,3.214,0,0,0,1.921-1.838,6.586,6.586,0,0,0,.414-2.446.952.952,0,0,0-.033-.167c-.1.059-.186.1-.262.153a6.709,6.709,0,0,1-3.188,1.025,24.919,24.919,0,0,1-4.818-.208,33.679,33.679,0,0,0-4.793-.275,8.5,8.5,0,0,0-5.009,1.6c-.184.141-.355.3-.536.447a2.47,2.47,0,0,1-.219.149l-.059-.06a1.164,1.164,0,0,1,.119-.179,4.928,4.928,0,0,0,1.271-2.79,15.308,15.308,0,0,0,.071-3.8c-.116-1.39-.246-2.78-.333-4.171-.066-1.027-.113-2.058-.1-3.085a9.245,9.245,0,0,1,.791-3.838,6.04,6.04,0,0,1,3.831-3.223.564.564,0,0,1,.157-.031c1.235,0,2.47,0,3.719.048l-.387.111a7.587,7.587,0,0,0-2.6,1.237,5.605,5.605,0,0,0-2.059,3.365,14.316,14.316,0,0,0-.191,3.983c.044.777.124,1.552.168,2.328.049.866.107,1.734.1,2.6a6.909,6.909,0,0,1-.354,2.433,14.031,14.031,0,0,1-.669,1.366c-.044.089-.1.173-.145.26l.056.057a.93.93,0,0,0,.184-.1,5.34,5.34,0,0,1,3.215-1.342,21.152,21.152,0,0,1,4.26.085c1.175.115,2.351.235,3.53.266a9.284,9.284,0,0,0,2.153-.209,2.743,2.743,0,0,0,2.279-2.5,13.808,13.808,0,0,0,.057-1.579,1.569,1.569,0,0,0-.068-.324c-.112.068-.2.112-.271.168a5.071,5.071,0,0,1-3.118,1.078c-1.073,0-2.144-.049-3.214-.1a8.784,8.784,0,0,0-5.921,1.676,2.523,2.523,0,0,1-.234.142l-.06-.053a1.592,1.592,0,0,1,.13-.232,5.68,5.68,0,0,0,1.246-3.589c.018-1.052-.092-2.108-.126-3.163a12.627,12.627,0,0,1,.158-3.342,6,6,0,0,1,2.81-3.715c.2-.126.4-.236.6-.358a4.024,4.024,0,0,1,2.394-.618c1.242.059,2.489.014,3.734.015a3.905,3.905,0,0,1,3.888,3.883q0,9.475,0,18.948a3.884,3.884,0,0,1-3.893,3.9q-9.393,0-18.786,0a3.887,3.887,0,0,1-3.88-3.882V382.118a3.9,3.9,0,0,1,3.872-3.872q2.244,0,4.488,0c.085,0,.169.008.332.015"
                      transform="translate(-141.28 -378.225)"
                    />
                  </g>
                </g>
              </svg>
              <div class="contentSubtitle">
                {{ $t('loginScreen.subtitle') }}
              </div>
            </div>
            <div class="the-journey-logo mb-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="203.116"
                height="45.643"
                viewBox="0 0 203.116 45.643"
              >
                <g transform="translate(-91.71 -201.6)">
                  <g transform="translate(91.71 204.814)">
                    <path
                      class="a"
                      d="M165.985,205.47c-.264,0-26.535.359-35.967.568-8.76.194-22.887.221-31.327.237-2.073,0-3.8.008-5,.012-1.121,0-1.608.007-1.819.029-.027,0-.045,0-.053,0l0,.011c-.106.017-.106.044-.106.088s0,.068.106.086l0,.012.064,0c.24.024.812.027,2.18.036,1.435.009,3.481.017,5.921.027,8.421.034,21.147.086,30.034.24,6.8.118,35.676.478,35.967.482h0a.087.087,0,0,0,.064-.029.106.106,0,0,0,.027-.071v-1.619a.106.106,0,0,0-.027-.072.114.114,0,0,0-.065-.029"
                      transform="translate(-91.71 -205.469)"
                    />
                    <path
                      class="a"
                      d="M320.971,206.263l0-.012c-.009,0-.031,0-.064,0-.24-.025-.812-.028-2.18-.037-1.435-.009-3.482-.017-5.921-.027-8.421-.034-21.148-.086-30.035-.24-6.8-.118-35.675-.478-35.967-.482h0a.087.087,0,0,0-.064.029.106.106,0,0,0-.027.072v1.619a.106.106,0,0,0,.027.071.085.085,0,0,0,.064.03h0c.264,0,26.535-.359,35.967-.568,8.76-.194,22.887-.222,31.327-.238,2.073,0,3.8-.007,5-.012,1.121,0,1.608-.007,1.819-.028l.053,0,0-.011c.106-.017.106-.044.106-.087s0-.069-.106-.086"
                      transform="translate(-117.961 -205.469)"
                    />
                    <path
                      class="b"
                      d="M143.671,248.656c5.875,0,10.635-4.909,10.635-11.3a10.64,10.64,0,1,0-21.27,0c0,6.4,4.722,11.3,10.635,11.3m0-24.654a13.213,13.213,0,0,1,13.313,13.349,13.317,13.317,0,1,1-26.624,0A13.213,13.213,0,0,1,143.671,224"
                      transform="translate(-98.256 -208.608)"
                    />
                  </g>
                  <path
                    class="b"
                    d="M273.769,224.54h20.012v2.305H276.335v9.52H291.55v2.305H276.335v9.706H294.45v2.305H273.769Z"
                    transform="translate(-30.834 -3.885)"
                  />
                  <g transform="translate(91.716 220.655)">
                    <path
                      class="b"
                      d="M103.415,224.54v2.305h12.063l.086,6.762s-.086,1.609-.086,3.769c0,5.685-4.133,11.371-10.448,11.371-5.912,0-10.635-4.908-10.635-11.3,0-.065,0,0,0-.066h-2.68c0,.064,0,0,0,.066a13.218,13.218,0,1,0,26.412-.193V224.54Z"
                      transform="translate(-91.717 -224.54)"
                    />
                    <path
                      class="b"
                      d="M209.98,241.943V227.106h5.807c4.573,0,7.288,2.937,7.288,7.437,0,4.028-2.176,6.773-5.86,7.3q-.353.051-.722.075c-.207.013-.416.022-.631.022Zm9.213,2.1c.191-.061.38-.127.562-.2,3.553-1.409,5.7-4.843,5.7-9.34,0-5.912-3.756-9.965-9.557-9.965h-8.484v26.141h2.566v-6.135h5.7l7.741,6.089h4.15Z"
                      transform="translate(-111.312 -224.54)"
                    />
                  </g>
                  <path
                    class="b"
                    d="M258.074,224.54l-.011,14.221L240.43,224.592v-.05l0,0h-2.566V242.1h2.566V227.888l17.619,14.168.013,0v.023l.013.013v0h2.566V224.54Z"
                    transform="translate(-24.753 -3.885)"
                  />
                  <g transform="translate(155.659 220.655)">
                    <path
                      class="b"
                      d="M192.458,224.54v12.837c0,5.685-4.133,11.371-10.448,11.371-5.912,0-10.635-4.908-10.635-11.3,0-.065,0,0,0-.066h-.018V224.54H168.71v12.837h-.01c0,.064,0,0,0,.066a13.217,13.217,0,1,0,26.41-.193V224.54Z"
                      transform="translate(-168.698 -224.54)"
                    />
                    <path
                      class="a"
                      d="M244.888,255.065H255.6c.187,0,.289-.147.169-.243l-5.354-4.343a.3.3,0,0,0-.341,0l-5.354,4.343c-.12.1-.017.243.17.243"
                      transform="translate(-181.564 -228.924)"
                    />
                  </g>
                  <path
                    class="b"
                    d="M330.786,224.54h-3.147l-10.208,11.773L307.223,224.54h-3.146l11.781,13.588.286.329v12.288h2.566l.01-12.288.286-.329Z"
                    transform="translate(-35.967 -3.885)"
                  />
                  <path
                    class="b"
                    d="M194.413,203.331h-2.5V201.6h7.026v1.73h-2.5v6.519h-2.019Z"
                    transform="translate(-16.97 0)"
                  />
                  <path
                    class="b"
                    d="M210.2,201.6h2.019v3.3h3v-3.3h2.019v8.249h-2.019v-3.23h-3v3.23H210.2Z"
                    transform="translate(-20.068)"
                  />
                  <path
                    class="b"
                    d="M229.623,201.6h5.169v1.73h-3.15v1.5h2.514v1.731h-2.514v1.557h3.311v1.73h-5.33Z"
                    transform="translate(-23.357)"
                  />
                </g>
              </svg>
              <div class="text-center font-weight-bold beta">BETA</div>
            </div>
            <p class="mt-2 mb-6 text-center text-red font-weight-bold">
              {{ $t('loginScreen.newExperience') }}<br />
              <span v-html="$t('loginScreen.betaTestingHtml')"></span><br />
              {{ $t('loginScreen.thanksFeedback') }}
            </p>
            <v-alert color="#592892" class="text-center mb-6">{{
              $t('loginScreen.chromeBanner')
            }}</v-alert>
          </div>
          <p class="contentText start-your-journey">
            {{ $t('loginScreen.startJourney') }}
          </p>
          <v-card
            elevation="0"
            color="rgba(0,0,0,.0)"
            max-width="400px"
            class="login-options-container"
          >
            <FirebaseUI class="firebaseui" />
            <p class="contentText start-your-journey">
              {{ $t('loginScreen.signInNoPassword') }}
            </p>
            <div class="social-login">
              <v-btn
                @click="emailDialog = true"
                class="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised firebaseui-id-idp-button custom-sign-in-button send-link-email-button mb-3"
                elevation="1"
                color="#ffffff"
              >
                <v-icon
                  class="mr-3"
                  color="#A5D867"
                  size="18"
                  icon="mailicon"
                />{{ $t('loginScreen.sendLinkToEmail') }}
              </v-btn>
              <v-btn
                @click="openPhoneDialog"
                class="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised firebaseui-id-idp-button custom-sign-in-button send-code-phone-button"
                elevation="1"
                color="#fff"
              >
                <v-icon
                  class="mr-3"
                  color="#A5D867"
                  size="18"
                  icon="phoneicon"
                />{{ $t('loginScreen.sendCodeToPhone') }}
              </v-btn>
            </div>
            <v-alert
              v-if="feedback"
              border="start"
              color="#592892"
              density="compact"
              class="font-weight-bold mb-1"
              >{{ feedback }}</v-alert
            >
          </v-card>
          <AuthenticateUser v-on:authenticated="authenticated = $event" />
          <!-- Dialogs -->
          <v-dialog v-model="emailDialog" max-width="400px">
            <v-card
              :color="$vuetify.theme.dark ? '#2d2d2d' : 'rgba(255,255,255,.95)'"
            >
              <v-card-title class="text-h6 pb-0 justify-center">{{
                $t('loginScreen.passwordlessEmailTitle')
              }}</v-card-title>
              <!-- <p class="text-center mb-1">Sign In with Passwordless Email Link</p> -->
              <v-card-text class="email-password-login-form">
                <p v-if="authenticated" class="white-text center">
                  {{ authenticated.message }}
                </p>
                <v-form v-else ref="form" v-model="valid" v-on:submit.prevent>
                  <v-text-field
                    class="sign-in-with-email"
                    variant="solo"
                    :loading="loading2"
                    bg-color="rgba(165, 216, 103, .70)"
                    density="compact"
                    flat
                    name="email"
                    :placeholder="$t('loginScreen.emailPlaceholder')"
                    type="email"
                    v-model="email"
                    :rules="emailRules"
                    required
                    @keydown.enter="emailSignUp"
                  >
                  </v-text-field>
                </v-form>
                <v-card-actions>
                  <v-btn
                    class="text-white font-weight-bold text-subtitle-2 mx-auto"
                    variant="flat"
                    color="#A5D867"
                    :loading="loading2"
                    :disabled="!valid || loading2"
                    @click="emailSignUp"
                  >
                    {{ $t('loginScreen.getEmailLink') }}
                    <template #loader>
                      <span class="custom-loader">
                        <v-icon :icon="'cached'" />
                      </span>
                    </template>
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-model="phoneDialog" max-width="400px">
            <v-card
              :color="$vuetify.theme.dark ? '#2d2d2d' : 'rgba(255,255,255,.95)'"
            >
              <v-card-title class="text-h6 pb-0 justify-center">{{
                $t('loginScreen.signInWithPhone')
              }}</v-card-title>
              <v-card-text
                class="text-center text-red font-weight-bold pb-0 px-8"
                >{{ $t('loginScreen.phoneMustLink') }}</v-card-text
              >
              <div v-if="verifyPhone">
                <v-card-actions>
                  <v-text-field
                    class="sign-in-with-phone"
                    variant="outlined"
                    density="compact"
                    :placeholder="$t('loginScreen.verificationCode')"
                    v-model="otp"
                  >
                  </v-text-field>
                </v-card-actions>
                <v-card-actions>
                  <v-btn
                    class="text-white font-weight-bold text-subtitle-2 mx-auto mb-4"
                    variant="flat"
                    color="#A5D867"
                    :loading="phoneLoading"
                    @click="submitPhoneNumberAuthCode(otp)"
                  >
                    {{ $t('loginScreen.enterCode') }}
                    <template #loader>
                      <span class="custom-loader">
                        <v-icon :icon="'cached'" />
                      </span>
                    </template>
                  </v-btn>
                </v-card-actions>
              </div>
              <div v-else>
                <v-card-text class="phone-login-form">
                  <p v-if="authenticated" class="white-text center">
                    {{ authenticated.message }}
                  </p>
                  <v-form v-else ref="form" v-model="valid" v-on:submit.prevent>
                    <!-- <vue-tel-input-vuetify
                      v-model="phone"
                      clearable
                      required
                      @update:modelValue="onPhoneInput"
                      :rules="[
                        (v) => results.isValid || 'Enter a valid phone number',
                      ]"
                      label="Phone Number"
                    /> -->
                    <v-phone-input
                      v-model="phone"
                      :rules="getPhoneRules()"
                      :label="$t('loginScreen.phoneLabel')"
                      :country-label="$t('loginScreen.countryLabel')"
                      :country-aria-label="$t('loginScreen.countryLabel')"
                      :invalid-message="$t('loginScreen.phoneInvalid')"
                      variant="outlined"
                      density="comfortable"
                      filled
                      show-country-code
                      default-country="US"
                      clearable
                      required
                    />
                  </v-form>
                  <v-card-actions>
                    <v-btn
                      class="text-white font-weight-bold text-subtitle-2 mx-auto mt-4"
                      variant="flat"
                      id="sign-in-button"
                      color="#A5D867"
                      :loading="phoneLoading"
                      :disabled="!isPhoneValid() || phoneLoading"
                      @click="getVerificationCode"
                    >
                      {{ $t('loginScreen.getVerificationCode') }}
                      <template #loader>
                        <span class="custom-loader">
                          <v-icon :icon="'cached'" />
                        </span>
                      </template>
                    </v-btn>
                  </v-card-actions>
                  <div id="recaptcha-container"></div>
                </v-card-text>
              </div>
            </v-card>
          </v-dialog>
          <Tour />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // import firebase from 'firebase'
  import { mapState } from 'vuex'
  import AuthenticateUser from '@/components/auth/AuthenticateUser'
  import Tour from '@/components/utilities/Tour'
  // import { VueTelInputVuetify } from "vue-tel-input-vuetify";
  import FirebaseUI from '@/components/utilities/FirebaseUI'
  import { isValidPhoneNumber } from 'libphonenumber-js'
  import { isValidEmailAddress } from '@/helpers/isValidEmailAddress'

  export default {
    name: 'Login',
    components: {
      AuthenticateUser,
      Tour,
      // VueTelInputVuetify,
      FirebaseUI,
    },
    data() {
      return {
        authenticated: false,
        resetPWDialog: false,
        feedback: null,
        loader: null,
        loading: false,
        loading2: false,
        phoneLoading: false,
        loading3: false,
        loading4: false,
        loading5: false,
        loading6: false,
        valid: false,
        validEmail: false,
        email: '',
        emailDialog: false,
        phone: '',
        phoneDialog: false,
        phoneEmail: '',
        otp: '',
        resetemail: '',
        password: '',
        hidePassword: true,
        pwresetvalid: false,
        newPassword: '',
        verifyEmail: false,
        verifyPhone: false,
      }
    },
    computed: {
      emailRules() {
        return [
          (v) => !!v || this.$t('loginScreen.emailRequired'),
          (v) =>
            isValidEmailAddress(v) || this.$t('loginScreen.emailInvalid'),
        ]
      },
      passwordType() {
        return this.hidePassword ? 'password' : 'text'
      },
      passwordIcon() {
        return this.hidePassword ? 'fa-eye' : 'fa-eye-slash'
      },
      ...mapState('UserData', ['user']),
    },
    watch: {
      loader() {
        const l = this.loader
        this[l] = !this[l]
        this.loader = null
      },
    },
    methods: {
      getPhoneRules() {
        return [
          (v) => !!v || this.$t('loginScreen.phoneRequired'),
          (v) =>
            isValidPhoneNumber(v || '', 'US') ||
            this.$t('loginScreen.phoneInvalid'),
        ]
      },
      isPhoneValid() {
        return isValidPhoneNumber(this.phone || '', 'US')
      },
      openPhoneDialog() {
        this.phoneDialog = true
        this.phoneLoading = false
      },
      loginWithSocial(network) {
        // reset GID in store
        this.$store.dispatch('AppData/setChurchId', null)

        this.$store.dispatch('UserData/socialLogin', network)
      },
      submit() {
        this.loader = 'loading'

        // reset GID in store
        this.$store.dispatch('AppData/setChurchId', null)

        // we set a delay so the user sees something happen when they click the button
        setTimeout(() => {
          if (this.$refs.form.validate()) {
            this.$store.dispatch('UserData/userLogin', {
              email: this.email,
              password: this.password,
              redirect: this.$route.query.redirect,
            })
          } else {
            this.loader = null
            this.loading = false
          }
        }, 1000)
      },
      emailSignUp() {
        this.loader = 'loading2'
        // we set a delay so the user sees something happen when they click the button
        setTimeout(() => {
          if (this.$refs.form.validate()) {
            this.$store.dispatch('UserData/userLoginWithEmailLink', {
              email: this.email,
            })
          } else {
            this.loader = null
            this.loading2 = false
          }
        }, 1000)
      },
      // verifiyEmailForPhone() {
      //     this.loader = 'loading2'
      //     // we set a delay so the user sees something happen when they click the button
      //     setTimeout(() => {
      //         if (this.$refs.form.validate()) {
      //             console.log('1 ', this.phoneEmail, this.user.phone)
      //             // this.$store.dispatch('UserData/linkEmailToPhone', {
      //             //     email: this.phoneEmail,
      //             //     phone: this.user.phone,
      //             // });

      //         } else {
      //             this.loader = null
      //             this.loading2 = false
      //         }
      //     }, 1000);
      // },
      async getVerificationCode() {
        this.phoneLoading = true
        const phoneNumber = (this.phone || '').trim()

        try {
          if (!this.isPhoneValid()) {
            this.feedback = this.$t('loginScreen.phoneInvalid')
            this.verifyPhone = false
            return
          }

          const result = await this.$store.dispatch(
            'UserData/userGetPhoneVerificationCode',
            {
            phone: phoneNumber,
            }
          )
          this.verifyPhone = Boolean(result && result.ok)
        } catch (e) {
          console.error('🔥 Phone verification failed:', e)
          this.feedback =
            'Phone verification failed. Please try again in a few seconds.'
          this.verifyPhone = false
        } finally {
          this.phoneLoading = false
        }
      },
      submitPhoneNumberAuthCode(otp) {
        this.phoneLoading = true
        // console.log('submitPhoneNumberAuthCode called ', otp)
        setTimeout(() => {
          Promise.resolve(
            this.$store.dispatch('UserData/signInWithPhone', {
              otp: otp,
            })
          ).finally(() => {
            this.phoneLoading = false
          })
        }, 1000)
      },
      register() {
        this.loader = 'loading2'
        // we set a delay so the user sees something happen when they click the button
        setTimeout(() => {
          if (this.$refs.form.validate()) {
            this.$store.dispatch('UserData/userJoin', {
              email: this.email,
              password: this.password,
            })
          } else {
            this.loader = null
            this.loading2 = false
          }
        }, 1000)
      },
      verifyUsersEmail() {
        this.loader = 'loading3'
        // we set a delay so the user sees something happen when they click the button
        setTimeout(() => {
          this.$store.dispatch('UserData/verifyUsersEmail')
        }, 1000)
      },
      openResetPWDialog() {
        this.feedback = null
        this.loader = 'loading4'
        // we set a delay so the user sees something happen when they click the button
        setTimeout(() => {
          this.resetPWDialog = true
          this.loader = null
          this.loading4 = false
        }, 1000)
      },
      resetPW() {
        this.loader = 'loading5'
        // we set a delay so the user sees something happen when they click the button
        setTimeout(() => {
          if (this.$refs.resetform.validate()) {
            this.$store.dispatch('UserData/resetUserPW', {
              email: this.resetemail,
            })
            this.resetPWDialog = false
            this.loader = null
            this.loading5 = false
          } else {
            this.loader = null
            this.loading5 = false
          }
        }, 1000)
      },
      submitNewPassword() {
        this.loader = 'loading6'
        // we set a delay so the user sees something happen when they click the button
        setTimeout(() => {
          this.authenticated.message = this.$t('loginScreen.confirmingPassword')
          // Save the new password.
          this.authenticated.auth
            .confirmPasswordReset(
              this.authenticated.actionCode,
              this.newPassword
            )
            .then(() => {
              // Password reset has been confirmed and new password updated.
              this.authenticated.message = this.$t('loginScreen.passwordReset')
              // TODO: Display a link back to the app, or sign-in the user directly
              // if the page belongs to the same domain as the app:
              // auth.signInWithEmailAndPassword(accountEmail, newPassword);
              setTimeout(() => {
                this.$store.dispatch('UserData/userLogin', {
                  email: this.authenticated.email,
                  password: this.newPassword,
                })

                // this.loader = null
                // this.loading6 = false
              }, 1000)

              // TODO: If a continue URL is available, display a button which on
              // click redirects the user back to the app via continueUrl with
              // additional state determined from that URL's parameters.
            })
            .catch(function (error) {
              // Error occurred during confirmation. The code might have expired or the
              // password is too weak.
              console.log('Error occurred during confirmation ', error)
            })
        }, 1000)
      },
    },
    created() {
      // console.log('we are at login')
      //watch for error message
      this.$store.watch(
        () => {
          return this.$store.getters['UserData/getLoginFeedback'] // could also put a Getter here
        },
        (newValue) => {
          // console.log('newValue', newValue)
          //something changed do something
          if (newValue) {
            if (
              newValue.code &&
              (newValue.code == 'resubmit-verification' ||
                newValue.code == 'no-verfied email')
            ) {
              this.emailDialog = true
              this.phoneDialog = false
            }
            if (newValue.code && newValue.code == 'phone-verified') {
              this.verifyPhone = true
            }
            if (
              (newValue.code && newValue.code == 'signed in') ||
              newValue.code == 'no-phone' ||
              newValue.code == 'no-verification-code' ||
              newValue.code == 'phone-not-linked'
            ) {
              this.verifyPhone = false
              this.phoneDialog = false
              this.phone = ''
              this.otp = ''
            }
            if (newValue.code && newValue.code == 'email-link') {
              this.emailDialog = false
            }
            this.feedback = newValue.message

            this.loader = null
            this.loading = false
            this.loading2 = false
            this.phoneLoading = false
            this.loading3 = false
          }
        },
        //Optional Deep if you need it
        {
          deep: true,
        }
      )
      // if the user is logged in route them to home
      if (this.$store.getters.getUser && this.$store.getters.getUser.verified)
        this.$router.replace('home')
    },
  }
</script>

<style>
  .login .login-bg-img-container {
    position: fixed;
    z-index: 0;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url(../../assets/mountains.jpg);
    background-size: cover;
    filter: grayscale(100%) blur(0px);
    background-repeat: no-repeat;
    /* background-position: 50% 0; */
  }
  .login-bg-img-container:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.85);
  }
  /* .login .v-input.error--text {
    padding-bottom: 10px;
} */
  .login .v-card__actions {
    padding: 0 16px 16px;
  }
  .login input[type='email']:not(.browser-default),
  .v-dialog input[type='email']:not(.browser-default),
  .login input[type='password']:not(.browser-default),
  .login input[type='text']:not(.browser-default),
  .login input[type='email']:not(.browser-default):focus:not([readonly]),
  .login input[type='password']:not(.browser-default):focus:not([readonly]),
  .login input[type='text']:not(.browser-default):focus:not([readonly]) {
    margin-bottom: 0;
    /* padding: 5px 10px; */
    border-radius: 3px;
    border-top: none;
    border-bottom: none;
  }
  .login .v-input__append-inner {
    margin-top: 9px !important;
    margin-right: 4px;
  }
  .login .v-input__slot {
    background: rgba(165, 216, 103, 0.7);
    border-radius: 3px;
    border: 1px solid transparent;
    border-top: none;
    border-bottom: 1px solid #ddd;
  }
  .login input[type='email']:not(.browser-default):disabled {
    color: #000;
  }
  /* .login .v-label.v-label--active {
    top: 0;
    color: #fff;
} */
  /* .login .v-input__append-inner .v-icon.primary--text {
    color:#fff !important;
} */
  /* .login .v-label.primary--text,
.login .v-input--is-focused.primary--text {
    color: #66ccff !important;
} */
  /* .login .v-label.error--text,
.login .v-input--is-focused.v-input.error--text,
.login .v-messages.error--text {
    color: #ff9797 !important;
} */
  /* .login .contentTitle {
    font-size: 12vw;
    color: rgba(255,255,255,.75);
    text-align: center;
    position: relative;
}
.login .contentTitle span {
    color: rgba(244, 67, 54, 0.75);
}
.login .contentSubtitle {
    font-weight: 600;
    font-size: 2.15em;
    margin-top: -40px;
    margin-bottom: 5px;
    text-transform: uppercase;
    position: relative;
    text-align: center;
    color: rgba(255,255,255, 0.75);
} */
  .login .contentSection {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .login .contentSubtitle {
    color: #000;
    font-weight: 700;
    font-size: 15px;
    margin-top: 7px;
    margin-bottom: 20px;
  }
  .login .contentText {
    font-size: 1.5em;
    /* max-width: 600px; */
    /* font-weight: 400; */
    /* margin-bottom: 0; */
    position: relative;
    text-align: center;
    /* color: rgba(255,255,255, 0.75); */
  }
  .login p {
    color: #000;
  }
  .social-login,
  .input-label {
    text-align: center;
    /* color: rgba(255,255,255,.7); */
    padding: 0 16px;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .input-label {
    margin-top: 0px;
  }
  .social-login p,
  .input-label {
    margin-bottom: 10px;
    background: rgba(0, 0, 0, 0.15);
  }
  .social-login img {
    max-width: 250px;
  }
  .social-login .social-button {
    /* margin-right: 5%; */
    line-height: 0;
  }
  .social-login .social-button:focus {
    outline: none;
    background-color: transparent;
  }
  .social-login .social-button.twitter {
    margin-right: 0;
  }
  .email-password-login-form {
    padding-top: 0;
    padding-bottom: 0;
  }
  .login .the-journey-logo {
    margin: 60px 0;
  }
  .login .v-card {
    margin: auto;
  }
  .v-text-field.sign-in-with-phone .v-text-field__details {
    margin-bottom: 0;
  }
  .v-card__title.word-break-none {
    word-break: normal;
  }
  body .v-application .firebaseui-idp-list {
    padding-left: 0;
    margin-bottom: 0;
  }
  body .mdl-button.custom-sign-in-button {
    text-transform: none;
    color: #757575;
  }
  body .mdl-button.custom-sign-in-button .v-btn__content {
    justify-content: start;
  }
  body .mdl-button.custom-sign-in-button:hover::before {
    opacity: 0;
  }
  body .mdl-button.firebaseui-idp-password {
    background-color: #ffffff !important;
  }
  /* body .mdl-button.firebaseui-idp-password img {
    filter: brightness(0.5);
} */
  body .mdl-button.firebaseui-idp-password .firebaseui-idp-text {
    color: #757575;
  }
  body .mdl-button.firebaseui-idp-password .firebaseui-idp-icon {
    width: 18px;
    height: 18px;
    background-size: cover;
    background-image: url('data:image/svg+xml;base64,PCEtLSBDb3B5cmlnaHQgKGMpIDIwMTYgR29vZ2xlIEluYy4gQWxsIHJpZ2h0cyByZXNlcnZlZC4gLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9IiNhNWQ4NjciPgogICAgPHBhdGggZD0iTTIwIDRINGMtMS4xIDAtMS45OS45LTEuOTkgMkwyIDE4YzAgMS4xLjkgMiAyIDJoMTZjMS4xIDAgMi0uOSAyLTJWNmMwLTEuMS0uOS0yLTItMnptMCA0bC04IDUtOC01VjZsOCA1IDgtNXYyeiIvPgogICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPgo8L3N2Zz4K');
    background-size: cover;
    background-repeat: no-repeat;
    padding-left: 18px;
  }
  /* @media screen and (max-width: 1024px) {
    .login .contentText {
        padding: 0 20px;
        font-size: 1.25em;
    }
    .login .contentSubtitle {
        font-size: 4.15vw;
    }
}
@media screen and (max-width: 55em) {
    .login .contentSubtitle {
        margin-top: -20px;
    }
    .login .contentTitle {
        font-size: 20vw;
    }
} */
</style>
